<template>
  <BaseIdCard :numberPerRow="4" @click="needRenderAdminButton ? toogleAdminButton() : closeEditMode()"
    :innerClass="'border-b-8'" :style="{'border-color': produit.couleur.code}">

    <div class="flex flex-row justify-between gap-4">
      <TitreDeux v-show="!isEditMode" :content="produit.nombre  + 'x ' + produit.nom" />
      <InputField @click.stop :placeholder="t('inputProductName')" v-show="isEditMode" v-model="editName"
        class="text-xl font-semibold !w-full"/>

      <etat-chips v-if="!isEditMode" :etat="props.produit.etat" />
    </div>

    <div class="flex flex-col">
      <DropDownField @click.stop :label="t('color')" showLabel :placeholder="t('selectAColor')" v-model="editColor"
         v-show="isEditMode" :values="couleurStore.couleurs.map(c => ({
            id: c.uuid,
            display: c.libelle
         }))" />

      <DropDownField @click.stop :label="t('filamentType')" showLabel :placeholder="t('selectAColor')" v-model="editTypeFilament"
           v-show="isEditMode" :values="typeFilamentStore.typeFilaments.map(c => ({
            id: c.uuid,
            display: c.libelle
         }))" />

      <div class="flex flex-row gap-2">
        <InputField @click.stop :placeholder="t('inputQuantity')" :label="t('quantity')" showLabel v-show="isEditMode" v-model="editQuantity"
                    :min="1" type="number" class="!w-1/2"/>

        <DropDownField @click.stop :placeholder="t('filling')" v-model="editFilling" v-show="isEditMode"
                       :values="utils.getFillingValues()" showLabel class="!w-1/2" />
      </div>

      <BaseKeyValue :cles="t('filling')"  v-show="!isEditMode">
        <SimpleText :content="produit.remplissage + '%'" />
      </BaseKeyValue>

      <BaseKeyValue :cles="t('filamentType')"  v-show="!isEditMode">
        <SimpleText :content="produit.typeFilament.libelle + ' - ' + produit.prixKgFilament + '€/kg' " />
      </BaseKeyValue>

      <BaseKeyValue :cles="t('progress')"  v-show="isEnImpression">
        <SimpleText :content="produit.nombrePrinted + ' / ' + produit.nombre + ' ' + t('printedProduct') " />
      </BaseKeyValue>


      <BaseKeyValue :cles="t('information')" v-if="showTempValue && showPoidValue">
        <SimpleText :content="converter.minToDays(produit.temp) + ' - ' + produit.poid + 'g'" />
      </BaseKeyValue>

      <BaseKeyValue :cles="t('printer')" v-if="showPrinterValue">
        <SimpleText :content="produit.imprimante.marque + ' ' + produit.imprimante.modele" />
      </BaseKeyValue>

      <div v-show="showAdminButtonEnImpression">
        <div class="flex flex-row gap-2" v-show="!hasAlreadyPrintProduct">
          <InputField @click.stop :placeholder="t('weights')" v-model="poidEdit"
                      type="number" :min="1" showLabel/>

          <InputField @click.stop :placeholder="t('time')" v-model="tempsEdit"
                      :min="1" @onChange="resolveMathTemps" showLabel/>
        </div>

        <InputField @click.stop :placeholder="t('nbProductPrinted')" v-model="nbAddProduit"
                    type="number" :min="1" :max="nbProduitRemainingToPrint" showLabel/>

        <BaseKeyValue :cles="t('coil')" v-show="poidEdit > 0 && nbAddProduit > 0">
          <BlueClickableText  :text="t('selectCoil')" @click.stop="() => showModalBobine = true"/>
        </BaseKeyValue>

        <DropDownField @click.stop :placeholder="t('chooseAPrinter')" v-model="printerUsed" :label="t('printer')" showLabel v-show="!hasAlreadyPrintProduct"
           :values="imprimanteStore.imprimantes.map(p => ({
              id: p.uuid,
              display: `${p.marque} ${p.modele}`
           }))" />

        <BlueClickableText :text="t('addAFailedObject')" @click.stop="showCreateFailedModal(produit.uuid)" class="w-full flex flex-row justify-center" />
      </div>
    </div>

    <div class="flex flex-row justify-center items-center gap-2 mt-2" @click.stop="() => {showFailedPrint = !showFailedPrint}"
      v-if="hasFailed">
      <SimpleText :content="t('showFailedPrint')" />
      <BlackUpIcon v-show="!showFailedPrint"/>
      <BlackDownIcon v-show="showFailedPrint"/>
    </div>

    <IdCardFailed v-show="showFailedPrint" v-for="failed of produit.failed" :key="failed.uuid" :failed="failed"/>

    <div class="mt-4 text-center flex flex-row justify-center items-center gap-2">
      <BlueDownloadRoundedIcon v-show="!isEditMode" @click.stop="downloadStl" />
      <BlueCubesRoundedIcon @click.stop="show3DRenderModal" />
      <BlueEditRoundedIcon v-show="isNotEditModeEtAFaire" @click.stop="isEditMode = true" />

      <OrangeForwardRoundedIcon v-if="showAdminButtonAFaire && isAdmin" @click.stop="setStatusWIP" />
      <GreyCrossRoundedIcon v-if="showAdminButtonAFaire" @click.stop="setStatusCancel" />

      <PurpleFileInputField
        @click.stop
        v-show="isEditMode"
        v-model="editValueStl"
        :defaultValue="editValueStl.name"
        class="col-span-2"/>

      <GreenCheckRoundedIcon @click.stop="updateProduit" v-show="isEditMode" />
      <GreenCheckRoundedIcon v-show="isAdminAndShowAdminButton && isEnImpression" @click.stop="setToPrinted" />
    </div>

    <ModalChoixBobinePourProduit ref="modalElement" :isVisible="showModalBobine" :close-modal="closeModalSelectedBobine" :nb-produit="nbAddProduit" :poid-produit="poidEdit" :bobines-de-la-couleur="bobinesDeLaCouleurDuProduit" />
  </BaseIdCard>
</template>

<script setup>
import {computed, defineProps, reactive, ref, useTemplateRef, watch} from 'vue';
import EtatChips from "@/components/molecules/EtatChips.vue";
import xhr from "@/utils/xhr";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {NotificationStores} from "@/stores/NotificationStores";
import {CommandeStores} from "@/stores/CommandeStores";
import {enumeration} from '../../../Enumeration';
import {BobineStore} from "@/stores/BobineStore";
import {parser} from "mathjs";
import {jsonValidator} from "@/utils/JsonValidator";
import {t} from "@/utils/Traduction";
import {ImprimantesStore} from "@/stores/ImprimanteStore";
import {ProduitStores} from "@/stores/ProduitStore";
import ModalChoixBobinePourProduit from "@/components/organismes/ModalChoixBobinePourProduit.vue";
import {CouleurStore} from "@/stores/CouleurStore";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import InputField from "@/components/molecules/InputField.vue";
import BlueClickableText from "@/components/molecules/BlueClickableText.vue";
import BlackUpIcon from "@/components/atoms/BlackUpIcon.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import BlackDownIcon from "@/components/atoms/BlackDownIcon.vue";
import IdCardFailed from "@/components/organismes/IdCardFailed.vue";
import PurpleFileInputField from "@/components/molecules/PurpleFileInputField.vue";
import BaseIdCard from "@/components/molecules/BaseIdCard.vue";
import BaseKeyValue from "@/components/molecules/BaseKeyValue.vue";
import DropDownField from "@/components/molecules/DropDownField.vue";
import {utils} from "@/utils/other";
import BlueDownloadRoundedIcon from "@/components/atoms/BlueDownloadRoundedIcon.vue";
import BlueCubesRoundedIcon from "@/components/atoms/BlueCubesRoundedIcon.vue";
import BlueEditRoundedIcon from "@/components/atoms/BlueEditRoundedIcon.vue";
import OrangeForwardRoundedIcon from "@/components/atoms/OrangeForwardRoundedIcon.vue";
import GreyCrossRoundedIcon from "@/components/atoms/GreyCrossRoundedIcon.vue";
import converter from "@/utils/Converter";
import GreenCheckRoundedIcon from "@/components/atoms/GreenCheckRoundedIcon.vue";
import {TypeFilamentStore} from "@/stores/TypeFilamentStore";

const props = defineProps({
  produit: Object,
  etatCommande: String,
  showCreateFailedModal: Function,
  show3DRenderModalByUuid: Function,
  show3DRenderModalByBase64: Function
});

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();
const commandeStore = CommandeStores();
const bobineStore =  BobineStore();
const imprimanteStore = ImprimantesStore();
const produitStore = ProduitStores();
const couleurStore = CouleurStore();
const typeFilamentStore = TypeFilamentStore();

const isShowingAdminButton = ref(false);
const isEditMode = ref(false);
const poidEdit = ref(props.produit.poid || null);
const tempsEdit = ref();
const nbAddProduit = ref();
const printerUsed = ref(-1);
const isDownloadStl = ref(false);
const showFailedPrint = ref(false);
const selectedBobines = reactive({full: [], partial: []});
const showModalBobine = ref(false);
const editValueStl = ref({name: props.produit.nom, content: ""});
const editName = ref(props.produit.nom);
const editColor = ref(props.produit.couleur.uuid);
const editTypeFilament = ref(props.produit.typeFilament.uuid);
const editQuantity = ref(props.produit.nombre);
const editFilling = ref(props.produit.remplissage);
const modalElementRef = useTemplateRef("modalElement");

const isAFaire = computed(() => props.produit.etat.libelle === enumeration.etatObjet.A_IMPRIMER);
const isEnImpression = computed(() => props.produit.etat.libelle === enumeration.etatObjet.EN_IMPRESSION);
const isAdmin = computed(() => utilisateurStore.role === enumeration.role.ADMIN);
const hasPoid = computed(() => props.produit.poid !== 0);
const hasTemp = computed(() => props.produit.temp !== 0);
const showPoidValue = computed(() => hasPoid.value && !isShowingAdminButton.value);
const showTempValue = computed(() => hasTemp.value && !isShowingAdminButton.value);
const showPrinterValue = computed(() => props.produit.imprimante && !isShowingAdminButton.value);
const showAdminButtonEnImpression = computed(() => isShowingAdminButton.value && isEnImpression.value);
const showAdminButtonAFaire = computed(() => !isEditMode.value && isShowingAdminButton.value && isAFaire.value)
const hasFailed = computed(() => props.produit.failed && props.produit.failed.length > 0);
const isNotEditModeEtAFaire = computed(() => !isEditMode.value && isAFaire.value);
const isAdminAndShowAdminButton = computed(() => isAdmin.value && isShowingAdminButton.value)
const needRenderAdminButton = computed(() =>
    (isAdmin.value && !isEditMode.value && (isAFaire.value || isEnImpression.value))
    || (!isAdmin.value && isAFaire.value && !isShowingAdminButton.value)
)
const nbProduitRemainingToPrint = computed(() => props.produit.nombre - props.produit.nombrePrinted);
const hasAlreadyPrintProduct = computed(() => props.produit.nombrePrinted > 0);

const bobinesDeLaCouleurDuProduit = computed(() => {
  const filteredBobines = bobineStore.bobines.filter(bobine => bobine.couleur.uuid === props.produit.couleur.uuid);
  // Si aucune bobine correspondante n'est trouvée, retourner toutes les bobines
  return filteredBobines.length > 0 ? filteredBobines : bobineStore.bobines;
});

watch(poidEdit, () => {
  selectedBobines.full = [];
  selectedBobines.partial = [];
  if (modalElementRef.value) {
    modalElementRef.value.reset();
  }
});

watch(nbAddProduit, () => {
  selectedBobines.full = [];
  selectedBobines.partial = [];
  if (modalElementRef.value) {
    modalElementRef.value.reset();
  }
})

const show3DRenderModal = () => {
  if(editValueStl.value.content !== "" && isEditMode.value) {
    props.show3DRenderModalByBase64(editValueStl.value.content);
  } else {
    props.show3DRenderModalByUuid(props.produit.uuid);
  }
}

const downloadStl = async () => {
  produitStore.getStl(props.produit.uuid, (response) => {
    const stlFormated = response.response

    const link = document.createElement('a');
    link.href = stlFormated
    link.download = props.produit.nom + ".stl";
    link.click();

    isDownloadStl.value = false;
  });
}

const closeEditMode = () => {
  isEditMode.value = false;
}

const toogleAdminButton = () => {
  isShowingAdminButton.value = !isShowingAdminButton.value;
}

const setStatusWIP = async () => {
  xhr.addRequestToQueue("PUT", `/produits/${props.produit.uuid}/wip`, undefined, true, true, false,
    (response) => {
      if(response.code !== 200) {

        if(response.code === 0 || !jsonValidator.validate(response.response)) {
          notificationStore.addNotification(
              t("errorDuringServerConnexion"),
              "error");
        } else {
          notificationStore.addNotification(
              JSON.parse(response.response).message,
              "error");
        }
      } else {
        notificationStore.addNotification(
            t("productStatusUpdated"),
            "success");

        const newProduit = {...(props.produit)};
        newProduit.etat.libelle = enumeration.etatObjet.EN_IMPRESSION;
        commandeStore.updateProduitInCommandeSelected(newProduit);
        isShowingAdminButton.value = false;
      }
    });
}

const setStatusCancel = async () => {

  xhr.addRequestToQueue("PUT", `/produits/${props.produit.uuid}/cancel`, undefined, true, true, false,
    (response) => {
      if(response.code !== 200) {

        if(response.code === 0 || !jsonValidator.validate(response.response)) {
          notificationStore.addNotification(
              t("errorDuringServerConnexion"),
              "error");
        } else {
          notificationStore.addNotification(
              JSON.parse(response.response).message,
              "error");
        }
      } else {
        notificationStore.addNotification(
            t("productStatusUpdated"),
            "success");

        const newProduit = {...(props.produit)};
        newProduit.etat.libelle = enumeration.etatObjet.ANNULE;
        commandeStore.updateProduitInCommandeSelected(newProduit);
        isShowingAdminButton.value = false;
      }
    });
}

const updateProduit = () => {
  if(!editQuantity.value || editQuantity.value <= 0 || !editName.value || editName.value.trim() === "") {
    notificationStore.addNotification(
        t("needFillAllFields"),
        "error");
    return;
  }

  const data = {
    nom: editName.value,
    uuidCouleur: editColor.value,
    nombre: editQuantity.value,
    remplissage: editFilling.value,
    stl: editValueStl.value.content,
    uuidTypeFilament: editTypeFilament.value
  }

  xhr.addRequestToQueue("PUT", "/produits/" + props.produit.uuid, data, true, true, false,
    (response) => {
      if(response.code !== 200) {
        if(response.code === 0 || !jsonValidator.validate(response.response)) {
          notificationStore.addNotification(
              t("errorDuringServerConnexion"),
              "error");
        } else {
          notificationStore.addNotification(
              JSON.parse(response.response).message,
              "error");
        }
      } else {
        notificationStore.addNotification(
            t("productEditedSuccessfully"),
            "success");

        isEditMode.value = false;

        const selectedCommande = commandeStore.commandeSelected;

        const produit = selectedCommande.produits.find(p => p.uuid === props.produit.uuid);

        produit.nom = editName.value;
        produit.couleur = couleurStore.couleurs.find(c => c.uuid === editColor.value);
        produit.nombre = editQuantity.value;
        produit.remplissage = editFilling.value;
        produit.typeFilament = typeFilamentStore.typeFilaments.find(t => t.uuid === editTypeFilament.value);
        produit.prixKgFilament = produit.typeFilament.prixKg;

        editValueStl.value.name = editName.value;

        if(editValueStl.value.content) {
          produit.fichier = editValueStl.value;
        }
      }
  })
}

const setToPrinted = async () => {

  let toutEstSaisieSurLesBobines;
  let nbObjetFull = 0;

  if(selectedBobines.full.length > 0) {
    nbObjetFull = selectedBobines.full.reduce((acc, bobine) => acc + bobine.nbObjet, 0);
  }

  if(nbObjetFull === nbAddProduit.value) {
    toutEstSaisieSurLesBobines = true;

  } else {
    let poidObjetPartiel = 0;
    if(selectedBobines.partial.length > 0) {
      poidObjetPartiel = selectedBobines.partial.reduce((acc, bobine) => acc + bobine.poids, 0);
    }

    const poidObjetsPartielNeccesaire = (nbAddProduit.value - nbObjetFull) * poidEdit.value;
    toutEstSaisieSurLesBobines = poidObjetPartiel === poidObjetsPartielNeccesaire;
  }

  if(
      (!hasAlreadyPrintProduct.value && (!poidEdit.value || poidEdit.value <= 0 || !tempsEdit.value || poidEdit.value <= 0 || printerUsed.value === -1 || !toutEstSaisieSurLesBobines || !nbAddProduit.value || nbAddProduit.value <= 0))
      || (hasAlreadyPrintProduct.value && (!toutEstSaisieSurLesBobines || !nbAddProduit.value || nbAddProduit.value <= 0))) {
    notificationStore.addNotification(
        t("needFillAllFields"),
        "error");
    return
  }

  if(!hasAlreadyPrintProduct.value) {
    let isGoodForTemp;
    try {
      const evaluatedValue = parser().evaluate(tempsEdit.value.toString());
      isGoodForTemp = !isNaN(evaluatedValue);
    } catch(e) {
      isGoodForTemp = false;
    }
    if(!isGoodForTemp) {
      notificationStore.addNotification(
          t("weightNeedBeNumber"),
          "error");
      return;
    }
  }

  const formatedBobine = {
    full: selectedBobines.full.map(bobine => ({ uuid: bobine.bobine.uuid, nbObjet: bobine.nbObjet })),
    partial: selectedBobines.partial.map(bobine => ({ uuid: bobine.bobine.uuid, poids: bobine.poids }))
  };

  xhr.addRequestToQueue("PUT", `/produits/${props.produit.uuid}/printed`,
    {
      poid: hasAlreadyPrintProduct.value ? null : poidEdit.value,
      temp: hasAlreadyPrintProduct.value ? null : tempsEdit.value,
      bobines: formatedBobine,
      nbObjetToAddPrinted: nbAddProduit.value,
      uuidImprimante: hasAlreadyPrintProduct.value ? null : printerUsed.value
    }, true, true, false,
    (response) => {
      if(response.code !== 200) {

        if(response.code === 0 || !jsonValidator.validate(response.response)) {
          notificationStore.addNotification(
              t("errorDuringServerConnexion"),
              "error");
        } else {
          notificationStore.addNotification(
              JSON.parse(response.response).message,
              "error");
        }
      } else {
        notificationStore.addNotification(
            t("productUpdate"),
            "success");

        const updatedProduct = JSON.parse(response.response)

        const newProduit = {...(props.produit)};
        newProduit.poid = updatedProduct.poid;
        newProduit.temp = updatedProduct.temp;
        newProduit.nombrePrinted = updatedProduct.nombrePrinted;

        if(updatedProduct.nombrePrinted === updatedProduct.nombre) {
          newProduit.etat.libelle = enumeration.etatObjet.IMPRIMEE;
        }

        newProduit.imprimante = imprimanteStore.imprimantes.find(imprimante => imprimante.uuid === updatedProduct.uuidImprimante);
        commandeStore.updateProduitInCommandeSelected(newProduit);
        isShowingAdminButton.value = false

        console.log(formatedBobine)

        formatedBobine.full.forEach(bobine => {
          const bobineSelected = bobineStore.bobines.find(b => b.uuid === bobine.uuid);
          bobineSelected.poidsRestant -= (poidEdit.value * bobine.nbObjet);

          if(bobineSelected.poidsRestant <= 0) {
            bobineStore.bobines = bobineStore.bobines.filter(b => b.uuid !== bobine.uuid);
          } else {
            bobineStore.bobines = bobineStore.bobines.map(b => {
              if(b.uuid === bobine.uuid) {
                return bobineSelected;
              }
              return b;
            });
          }
        });
      }

      formatedBobine.partial.forEach(bobine => {
        const bobineSelected = bobineStore.bobines.find(b => b.uuid === bobine.uuid);
        bobineSelected.poidsRestant -= bobine.poids;

        if(bobineSelected.poidsRestant <= 0) {
          bobineStore.bobines = bobineStore.bobines.filter(b => b.uuid !== bobine.uuid);
        } else {
          bobineStore.bobines = bobineStore.bobines.map(b => {
            if(b.uuid === bobine.uuid) {
              return bobineSelected;
            }
            return b;
          });
        }
      });
    });

  nbAddProduit.value = null;
}

const resolveMathTemps = () => {
  try {
    tempsEdit.value = parser().evaluate(tempsEdit.value);
  } catch(e) {
    console.log("not good syntax");
  }
}

const closeModalSelectedBobine = (bobineSelected) => {
  if(bobineSelected) {
    selectedBobines.full = bobineSelected.full;
    selectedBobines.partial = bobineSelected.partial;
  }

  showModalBobine.value = false;
}
</script>

<style scoped>
</style>